import { Button, Modal } from 'antd';
import React, { ReactNode, useEffect, useState } from 'react';
import Api from '../../../../api/Api';
import localStorage from '../../../../utils/localStore';

type Props = {
  children?: ReactNode
}

enum CurrentRenderStateEnum {
  normal,
  acceptingInvitation,
  autoLogin
}

const getQueryParams = () => {
  let urlParams
  if (window.location.search.includes('invitationVersion%3D1')) {
    urlParams = new URLSearchParams(decodeURIComponent(window.location.search))
  } else {
    urlParams = new URLSearchParams(window.location.search)
  }

  return new URLSearchParams(urlParams)
};

const INVITATION_TOKEN = "invitationToken";

export default function InvitationModal({ children }: Props) {
  const [currentRenderState, setCurrentRenderState] = useState<CurrentRenderStateEnum>(CurrentRenderStateEnum.normal);
  const [confirmLoading, setConfirmLoading] = useState(true);
  const [modalText, setModalText] = useState("Finishing invitation process ...");
  const [open, setOpen] =  useState(false);

  useEffect(() => {
    const params = getQueryParams();
    const invitationVersion = params.get("invitationVersion");
    const invitationIv = params.get("invitationIv");
    const invitation = params.get("invitation");

    if (invitationVersion && invitationIv && invitation) {
      localStorage.set(INVITATION_TOKEN, {
        invitationVersion,
        invitationIv,
        invitation
      });
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    const invitationStored = localStorage.get(INVITATION_TOKEN);
    if (invitationStored?.invitation) {
      const { invitationVersion, invitationIv, invitation } = invitationStored;
      if (invitationVersion && invitationIv && invitation) {
        setCurrentRenderState(CurrentRenderStateEnum.acceptingInvitation);
        setOpen(true);
        localStorage.remove(INVITATION_TOKEN);
        callInvocationApi(invitation, invitationIv, invitationVersion);
      }
    }
  }, []);

  const callInvocationApi = React.useCallback(async (invitation: string, invitationIv: string, invitationVersion: string) => {
    const data: any = await Api.auth.invitationComplete( { invitation, invitationIv, invitationVersion });
    if (data) {
      setConfirmLoading(false);
      setCurrentRenderState(CurrentRenderStateEnum.autoLogin);
      setModalText("Signing in ...");
      (window.top || window).location.assign(`${Api.SERVER_DOMAIN}${Api.IISSite}/auth/signin`);
    }
    else {
      setConfirmLoading(false);
      setModalText("Invitation process did not finish successfully");
    }
  }, []);

  const handleOk = React.useCallback(() => {
    setOpen(false);
    setCurrentRenderState(CurrentRenderStateEnum.normal);
  },[currentRenderState]);

  if (currentRenderState === CurrentRenderStateEnum.acceptingInvitation || currentRenderState === CurrentRenderStateEnum.autoLogin) {
    return (
      <Modal
        title="Finishing user registration"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        footer={[
          currentRenderState !== CurrentRenderStateEnum.autoLogin && <Button key="autoLogin" type="primary" loading={confirmLoading} onClick={handleOk}>Ok</Button>
        ]}
      >
        <p>{modalText}</p>
      </Modal>
    )
  } else {
    return <>{children}</>
  }
}
